import { commonRequest } from "../../../../services/ApiCall";
import { Helpers } from "../../../../services/Helpers";

export const ItemServices = {
    itemList: async (data) => {
        const queryParams = new URLSearchParams();
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.limit);
        if (data.sectionId) {
            queryParams.append('sectionId', data.sectionId);
        }
        if (data.pageType) {
            queryParams.append('pageType', data.pageType);
        }
        queryParams.append('searchKey', data.filters?.searchKey || '');
        if (data.filters?.sortBy) {
            queryParams.append('sortBy', data.filters.sortBy);
            queryParams.append('sortType', data.filters.sortType || 'ASC');
        }
        if (data.filters?.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                }
            });
        }
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/manage-customer-app/item/list?${queryParams.toString()}`, {}, Helpers.token());
    },

    getItemById: async (id) => {
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/manage-customer-app/item/details/${id}`, {}, Helpers.token());
    },

    addItem: async (data) => {
        return await commonRequest("POST", `${Helpers.URL()}/api/admin/manage-customer-app/item/add`, data, Helpers.token());
    },

    updateItem: async (id, data) => {
        return await commonRequest("PUT", `${Helpers.URL()}/api/admin/manage-customer-app/item/update/${id}`, data, Helpers.token());
    },

    toggleStatus: async (id) => {
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/manage-customer-app/item/modify-status/${id}`, {}, Helpers.token());
    },

    deleteItem: async (id) => {
        return await commonRequest("DELETE", `${Helpers.URL()}/api/admin/manage-customer-app/item/delete/${id}`, {}, Helpers.token());
    },

    reorderItems: async (data) => {
        return await commonRequest("PUT", `${Helpers.URL()}/api/admin/manage-customer-app/item/reorder`, data, Helpers.token());
    },

    getSectionById: async (id) => {
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/manage-customer-app/section/details/${id}`, {}, Helpers.token());
    },

    getCategories: async () => {
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/service-category/getCategories`, {}, Helpers.token());
    },

    subCategoryList : async (data)=>{
        return await commonRequest("get",  `${Helpers.URL()}/api/admin/service-category/getSubCategories/${data.categoryId}`,{}, Helpers.token());
    },

    serviceList: async (subCategoryId) => {
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/service-master/getServicesBySubcategory/${subCategoryId}`, {}, Helpers.token());
    }
};
